// Module
var code = "<div class=\"tooltip-wrapper\" uib-tooltip=\"{{ $ctrl.tooltipText }}\" tooltip-append-to-body=\"{{ $ctrl.tooltipAppendToBody }}\" tooltip-placement=\"{{ $ctrl.tooltipPlacement }}\"></div> ";
// Exports
export default code;